export enum WatrToDoType {
    None = 0,
    Wage = 1,
    Travel = 2
}